'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumStepper = undefined;

var _bindAll2 = require('lodash/bindAll');

var _bindAll3 = _interopRequireDefault(_bindAll2);

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseStepper = require('./base-stepper');

var _baseStepper2 = _interopRequireDefault(_baseStepper);

var _numStepper = require('./num-stepper');

var _numStepper2 = _interopRequireDefault(_numStepper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stepper = function (_React$Component) {
  _inherits(Stepper, _React$Component);

  // TODO determine more appropriate PropTypes so that lint does not have to be disabled
  function Stepper(props) {
    _classCallCheck(this, Stepper);

    var _this = _possibleConstructorReturn(this, (Stepper.__proto__ || Object.getPrototypeOf(Stepper)).call(this, props));

    _this.state = {
      selectedIndex: Math.max((0, _findIndex3.default)(props.range, {
        value: props.value
      }), 0)
    };

    (0, _bindAll3.default)(_this, ['isHandleDisabled', 'handleStep', 'getDisplayValue']);
    return _this;
  }

  _createClass(Stepper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // In case we receive new props - map it back to the state.
      this.setState({
        selectedIndex: Math.max((0, _findIndex3.default)(nextProps.range, {
          value: nextProps.value
        }), 0)
      });
    }
  }, {
    key: 'getDisplayValue',
    value: function getDisplayValue() {
      return this.props.range[this.state.selectedIndex].name;
    }
  }, {
    key: 'handleStep',
    value: function handleStep(direction, isIntermediate) {
      var range = this.props.range;

      var min = 0;
      var max = range.length - 1;
      var selectedIndex = this.state.selectedIndex;

      var newIndex = Math.min(Math.max(min, selectedIndex + direction), max);

      // Don't trigger intermediate calls to the user.
      if (!isIntermediate) {
        this.props.onChange(range[newIndex], range[selectedIndex]);
      } else {
        // Update the state in case the props weren't changing.
        this.setState({
          selectedIndex: newIndex
        });
      }
    }
  }, {
    key: 'isHandleDisabled',
    value: function isHandleDisabled(direction) {
      if (direction === _baseStepper.ENUM_LEFT) {
        return this.state.selectedIndex === 0;
      } else if (direction === _baseStepper.ENUM_RIGHT) {
        return this.state.selectedIndex === this.props.range.length - 1;
      } else if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('NW Stepper - Invalid direction provided.');
      }

      // Let it be enabled by default
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        onHandleChange: this.handleStep,
        value: this.getDisplayValue(),
        isHandleDisabled: this.isHandleDisabled
      });

      return _react2.default.createElement(_baseStepper2.default, props);
    }
  }]);

  return Stepper;
}(_react2.default.Component);

Stepper.displayName = 'Stepper';
Stepper.propTypes = {
  onChange: _propTypes2.default.func,
  range: _propTypes2.default.array.isRequired, // eslint-disable-line react/forbid-prop-types
  value: _propTypes2.default.any // eslint-disable-line react/forbid-prop-types, react/require-default-props
};
Stepper.defaultProps = {
  onChange: function onChange() {}
};
exports.default = Stepper;
exports.NumStepper = _numStepper2.default;
Stepper.__docgenInfo = {
  'description': '',
  'displayName': 'Stepper',
  'props': {
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'range': {
      'type': {
        'name': 'array'
      },
      'required': true,
      'description': ''
    },
    'value': {
      'type': {
        'name': 'any'
      },
      'required': false,
      'description': ''
    }
  }
};